import React from 'react';
import CameraCapture from '../../components/CameraCapture';

function createUUID() {
  var dt = new Date().getTime();
  var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (dt + Math.random() * 16) % 16 | 0;
    dt = Math.floor(dt / 16);
    return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
  return uuid;
}

export default function camera({ route, navigation }) {
  const { fotoSeq } = route.params;
  const fileName = createUUID() + '_' + fotoSeq;

  function handleUploaded(URL) {
    route.params.refreshFoto(URL);
    route.params.refresh();
    navigation.goBack(null);
  }

  return (
    <CameraCapture navigation={navigation} fileName={fileName} onUploaded={handleUploaded} />
  );
}
